"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mail = void 0;
var mail = {
  "viewBox": "0 0 512 512",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"
    },
    "children": []
  }, {
    "name": "path",
    "attribs": {
      "d": "M256,176H128v160h128h128V176H256z M256,192h89.719L256,255.75L166.281,192H256z M144,196.531l54.5,36.859L144,292.812\r\n\tV196.531z M256,320h-92.406l45.562-79.422L256,272.25l46.844-31.672L348.406,320H256z M368,292.812l-54.5-59.422l54.5-36.859\r\n\tV292.812z"
    },
    "children": []
  }]
};
exports.mail = mail;